import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SecondaryLink } from 'jl-design-system/elements/link/Link';
import urlConstants from '../../constants/urlConstants';
import styles from './technical-error.scss';

export class TechnicalError extends PureComponent {

  static propTypes = {
    basketUrl: PropTypes.string,
    pageNotFoundTechnicalError: PropTypes.bool,
  };

  static defaultProps = {
    basketUrl: urlConstants.BASKET_PAGE_URL,
    pageNotFoundTechnicalError: false,
  };

  render() {
    const {
      pageNotFoundTechnicalError,
      basketUrl,
    } = this.props;

    let title;
    let message;
    let buttonText;

    if (pageNotFoundTechnicalError) {
      title = 'Sorry, this page is unavailable';
      message = 'Please return to basket and try again.';
      buttonText = 'Return to basket';
    } else {
      title = "Sorry, we've had a technical problem";
      message = 'Please return to the homepage.';
      buttonText = 'Return to the homepage';
    }

    return (
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.bodyupper}>{message}</p>
        <SecondaryLink
          className={styles.button}
          data-action="handback"
          to={basketUrl}
        >
          <span className={styles.buttontext}>{buttonText}</span>
        </SecondaryLink>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    basketUrl: state.bff.basketUrl,
  };
}

export default connect(state => mapStateToProps(state))(TechnicalError);
